import { ReactElement, useMemo } from 'react';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';

import {
  DashboardVariantV2Carrier,
  DashboardVariantV2Giver,
} from './CompanyType';

const DashboardVariantV2 = (): ReactElement => {
  const { isCarrier } = useTypePartnerCompany();

  const CompanyTypeComponent = useMemo(
    () => (isCarrier ? DashboardVariantV2Carrier : DashboardVariantV2Giver),
    [isCarrier],
  );

  return <CompanyTypeComponent />;
};

export default DashboardVariantV2;
